import { ChangeDetectorRef, Component, Input, OnInit, ViewChild, inject, DestroyRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { translate } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { ChangeTaskStatus } from 'src/app/models/change-task/change-task-column';
import { Constants } from 'src/app/models/constants';
import { Permission } from 'src/app/models/principal/permission';
import { RouterSegments } from 'src/app/models/router-segments';
import { Solution } from 'src/app/models/service/solution';
import { BlueprintsService } from 'src/app/services/api/blueprints.service';
import { InstancesService } from 'src/app/services/api/instances.service';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { DateTimeFormatService } from 'src/app/services/util/date-time-format.service';
import { ErrorPageService } from 'src/app/services/util/error-page.service';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { Attributes, Datazone, Permissions } from 'src/app/models/principal/permission';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ToastrErrorService } from 'src/app/services/util/toastr-error.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { ColumnFilterComponent } from '../instances-mgmt/column-filter/column-filter.component';
import { SolutionVersionsService } from 'src/app/services/util/solution-versions.service';
import { SolutionVersionsInfo } from 'src/app/models/service/solution-versions-info';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { combineLatest, map, Observable } from 'rxjs';
import { Blueprint } from 'src/app/models/blueprints/blueprint';
import { TenantService } from 'src/app/services/api/tenant.service';
import { DeploymentClass } from 'src/app/models/instance-class';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';


const REQUIRED_PERMISSIONS =  [
  { 
    key: PermissionKeys.BLUEPRINT_READ,
    action: Permissions.BLUEPRINT_READ
  }
];

@Component({
    selector: 'app-tenant-continuous-update',
    templateUrl: './tenant-continuous-update.component.html',
    styleUrls: ['./tenant-continuous-update.component.scss'],
    standalone: false
})
export class TenantContinuousUpdateComponent  implements OnInit  {
private destroyRef = inject(DestroyRef);

  @Input() selectedItem: any;
  @ViewChild(MatSort, {static: true}) sort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  Constants = Constants;
  tenant: string;
  enterpriseClient: boolean;
  breadcrumbItems: BreadcrumbItem[];

  RouterSegments = RouterSegments;
  data: any;
  tenantData: any;

  displayedColumns: string[] = ['serviceDefinition', 'solution', 'currentReleaseVersion', 'targetReleaseVersion', 'menu'];
  dataSource: any;
  selectedMenuItem: any;
  dashboard: any;
  showSpinner: any;
  dropdownsList: any = [];
  dashboardLink: any;
  tenantLink: any;
  instancesCount = 0;
  status: any;
  filteredColumns: any;
  clearData: boolean;
  subscription: Subscription;
  isReader: boolean;
  PermissionKeys = PermissionKeys;
  permissionsMap: { [key: string]: boolean };
  solutionId: string;
  lobName: any;
  solutionName: any;
  category: any;
  isFailed = false;
  pageSize: number;
  pageNumber = 1;
  showPagination = true;
  pageIndex = 0;
  paginationSize = 10;
  tenantId: string;
  serviceDefinitionList: any;
  solution: any;
  isAMR: boolean;
  dataLoaded = false;
  instances: any;
  isLive: boolean;
  serviceVersionsInfo: SolutionVersionsInfo;
  solutionVersions: any[];
  latestReleaseVersion: any;
  initialLoader = true;
  changeId: any;
  filterTenant: any;
  searchText: any;
  blueprint: any;


  readonly INSTANCE_DEPLOYED_STATES = [DeployStatus.DEPLOYED, DeployStatus.CONFIGURING,
    DeployStatus.CONFIGURATION_FAILED, DeployStatus.CONFIGURED, DeployStatus.UPDATING, DeployStatus.UPDATED, DeployStatus.TESTED, DeployStatus.TEST_FAILED];
    solutionNameFromSolution: any;

  constructor(private route: ActivatedRoute, private authService: AuthService,
    private sidenavService: SidenavService, private toastrService: CustomToastrService, public dateTimeFormatService: DateTimeFormatService,
    private instanceService: InstancesService, private permissionsService: PermissionsService, private solutionsService: SolutionsService,
    private router: Router, private toastrErrorService: ToastrErrorService, public solutionVersionsService: SolutionVersionsService, public tenantService: TenantService, public blueprintsService: BlueprintsService,
    private cdr: ChangeDetectorRef) {
    
  }

  ngOnInit(): void {
  this.tenantId = this.route.snapshot.params.id;
  this.sidenavService.tenantSelectedMenu = 'TENANT_LAYOUT.MENU.CONTINUOUS_UPDATE';

  this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
  if (!this.permissionsMap[PermissionKeys.BLUEPRINT_READ]) {
    this.router.navigate(['/', this.tenantId, 'tenant', 'permission-unauthorized'], {skipLocationChange: true});
  }
  this.getBlueprints();
  this.getTenants(this.tenantId);

 
    this.solutionId = this.route.snapshot.params.solutionId;
    this.dashboardLink = ({label: translate('LEFT_SIDE_NAV.DASHBOARDS')});
    this.tenantLink = ({label: translate('LEFT_SIDE_NAV.VIEW_TENANTS'), url: ['tenantlist']});
     }

     ngAfterViewChecked(){
      this.cdr.detectChanges();
    }


  getSolutionDetails(): void {
    this.showSpinner = true;
    this.solutionsService.getSolutionById(this.solutionId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.lobName = data.lineOfBusiness[0];
          this.solutionName = data.name;
          this.category = data.category;
          this.breadcrumbs();
        }
      },
      (error) => {
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }


  breadcrumbs(): void {
    this.breadcrumbItems = [];
    this.breadcrumbItems.push({icon: 'assets/images/home_icon.svg'},
      {label: translate('LEFT_SIDE_NAV.CONTINUOUS_UPGRADE')},
      {label: translate('LEFT_SIDE_NAV.SOLUTION'), url: ['updates-solution']},
      {label: (this.solutionName ? this.solutionName : '') + ' - ' + (this.tenantLink.label)});
  }

  getBlueprints(): void {
    this.pageIndex = 0;
    this.filterTenant = [];
    this.blueprintsService.getBlueprints(this.tenantId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((result: any) => {
      result = result.sort((a,b) => b?.dateCreated?.localeCompare(a?.dateCreated));
      this.initialLoader = false;
      this.filterTenant = result.filter(item => item.tenantId == this.tenantId);
      this.blueprint = this.filterTenant;
      this.serviceDefinitionList = this.filterTenant?.slice(this.pageIndex, this.paginationSize);
      if(this.serviceDefinitionList.length < 10) {
        this.loadData();
      }  
    }, (error) => {
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
    });
  }

  loadData(): void {
    this.serviceDefinitionList.forEach( blueprint => {
      const obj = {
        blueprintId: blueprint.id,
        tenantId: this.tenantId
      };
      combineLatest([
        this.solutionsService.getSolutionById(blueprint.solutionId),
        this.solutionsService.getSolutionVersions(blueprint.solutionId),
        this.instanceService.getInstances(obj)
      ])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(([solution,solutionVersion, instances]) => {

        this.solutionVersions = solutionVersion;
        this.instances = instances?.data;
        this.isLive = this.resolveLiveStatus(this.instances);
        this.serviceVersionsInfo = this.solutionVersionsService.getSolutionVersionsInfo(solutionVersion, this.solutionVersions, this.instances);
        const liveInstance = this.instances.find(instance => instance.deploymentClass === DeploymentClass.A);

        if (liveInstance) {
          this.latestReleaseVersion = this.solutionVersions.filter(version =>
            version.id === liveInstance.solutionVersionId)[0]?.releaseVersion;
        } else {
          const instanceLength = this.instances.length;
          const latestInstanceSolutionVersion = this.instances[instanceLength - 1]?.solutionVersionId;
          this.latestReleaseVersion = this.solutionVersions.filter(version =>
            version.id === latestInstanceSolutionVersion)[0]?.releaseVersion;
        }
        let releaseVersionText;
        if (this.latestReleaseVersion) {
          releaseVersionText = this.latestReleaseVersion;
        } else {
          releaseVersionText = this.serviceVersionsInfo?.currentVersion?.releaseVersion;
        }
        this.isAMR = releaseVersionText && this.solutionVersionsService.releaseVersion(releaseVersionText) ? true : false;
        if (this.instances?.length) {
          const latestSolutionId = this.instances[this.instances.length - 1]?.solutionId;
          let solutions;
          if (solution?.length) {
            solutions = solution?.find(version => version?.id == latestSolutionId);
          } else {
            solutions = solution;
          }
          blueprint.solutionName = solutions?.name;
 
        } else {
          blueprint.solutionName = solution?.name;
        }
        blueprint.solutionName = blueprint.solutionName ? blueprint.solutionName : 'N/A';
        blueprint.version = releaseVersionText;
        blueprint.isAMR = this.isAMR;
        this.dataLoaded = true;
      },
      (error) => {
        blueprint.solutionName = blueprint.solutionName ? blueprint.solutionName : 'N/A';
      });
    });

    if (this.serviceDefinitionList.length === 0) {
      this.dataLoaded = true;
    } 
  }

  searchBlueprint(event?): void {
    if (event) {
      this.searchText = event.target.value;
    } else if (this.searchText) {
      this.searchText = this.searchText;
    }

    this.blueprint = this.filterTenant;
    if (this.searchText) {
      this.blueprint = this.blueprint.filter(item => item?.name?.toLocaleLowerCase().includes(this.searchText.toLocaleLowerCase()));
    } else {
      this.blueprint = this.filterTenant;
    }
    this.pageIndex = 0;
    this.serviceDefinitionList = this.blueprint?.slice(this.pageIndex, this.paginationSize);
    this.loadData();
  }

  getTenants(tenantId): void {
    this.tenantService.getTenants(tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: any) => {
        this.tenant = data;
    });
  }

  private resolveLiveStatus(instances: any[]): boolean {
    const live = instances.find(instance => instance.deploymentClass === DeploymentClass.A);
    return this.INSTANCE_DEPLOYED_STATES.includes(live?.status);
  }



  openInstance(data): void {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.tenantId, RouterSegments.CONTINUOUS_UPDATE,
      RouterSegments.BLUEPRINTS, data.id]);
  }

  openInstanceDetails(data): void {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.tenantId, RouterSegments.CONTINUOUS_UPDATE,
      data.solutionId, data.id, RouterSegments.INSTANCE, data.testInstanceId]);
  }

  pageChanged(event): any {
    if (event.length) {
      this.pageIndex = event.pageIndex;
      this.paginationSize = event.pageSize;
      const firstIndex = this.pageIndex * this.paginationSize;
      this.serviceDefinitionList = this.blueprint.slice(firstIndex, firstIndex + this.paginationSize);
      this.loadData();
    }
  }
}